import { render } from "./functional_informationByIdView.vue?vue&type=template&id=974517ba"
import script from "./functional_informationByIdView.vue?vue&type=script&lang=js"
export * from "./functional_informationByIdView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__